import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, WebEnvironmentService } from '@dg/shared-services';

const AllowedOrgId = {
  Production: 1,
  Staging: 1,
  LocalStaging: 1,
  Local: 1,
};

@Injectable()
export class NgDocGuardService {
  constructor(
    private webEnvironmentService: WebEnvironmentService,
    private router: Router,
    private authService: AuthService
  ) {}

  public canActivate() {
    return this.checkOrgMembership();
  }

  public canLoad(): boolean {
    return this.checkOrgMembership();
  }

  public checkOrgMembership(): boolean {
    let isAllowed = false;
    const orgId = AllowedOrgId[this.webEnvironmentService.environment];

    // only allow for defined environments
    if (orgId) {
      const userOrgs: number[] = this.authService.authUser.orgInfo.map(
        (org) => org.organizationId
      );
      isAllowed = userOrgs.includes(orgId);
    }

    // if they aren't allowed, redirect them to an error page
    if (!isAllowed) {
      this.router.navigate(['/error']);
    }

    return isAllowed;
  }
}
